// removed by extract-text-webpack-plugin
module.exports = {"container":"partials-logo-container","expand":"partials-logo-expand","link":"partials-logo-link","dark":"partials-logo-dark"};


//////////////////
// WEBPACK FOOTER
// ./styles/partials/logo.scss
// module id = 698
// module chunks = 246